import {
  ViewSection,
  ViewSectionContent,
  ViewSectionHeader,
  ViewSectionTitle,
} from '@fortem-monorepo/react-spa'
import { ICGG2Report } from '@fortem-monorepo/web-sdk'

import { ContentBlocks } from '@/components/content-blocks/ContentBlocks'
import { IC_GUIDELINES_DATA_GRID_OVERRIDES } from '@/pages/funds/ic-guidelines-v2/content-block-config'

export interface BetaStageProps {
  output: ICGG2Report.NormalStageOutput
}

export const BetaStage: React.FC<BetaStageProps> = ({ output }) => {
  const blocks = output.blocks ?? []

  if (!blocks.length) {
    return null
  }

  return (
    <ViewSection>
      <ViewSectionHeader>
        <ViewSectionTitle>Beta</ViewSectionTitle>
      </ViewSectionHeader>
      <ViewSectionContent>
        <ContentBlocks blocks={blocks} dataGridOverrides={IC_GUIDELINES_DATA_GRID_OVERRIDES} />
      </ViewSectionContent>
    </ViewSection>
  )
}
